export default __webpack_public_path__ + "623d63a0904debb949d234dcfded2677.webp";